import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { axiosCredentials } from '@/axios-credentials'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: null,
    surname: null,
    firstname: null,
    isLoggedIn: false,
    isRegistered: false,
    project:{
      projectCode: null,
      workflowName: null,
      dataList: []
    }
  },
  getters: {
    accessToken: (state) => state.accessToken,
    surname: (state) => state.surname,
    firstname: (state) => state.firstname,
    isLoggedIn: (state) => state.isLoggedIn,
    isRegistered: (state) => state.isRegistered,
    projectCode: (state) => state.project.projectCode,
    workflowName: (state) => state.project.workflowName,
    dataList: (state) => state.project.dataList,
  },
  mutations: {
    setUserInfoToken(state, data) {
      // パスワードログイン時
      state.accessToken = data.accessToken
      state.surname = data.surname
      state.firstname = data.firstname
      state.isLoggedIn = true
      state.isRegistered = true
    },
    setUserInfo(state, data) {
      // /uiアクセスで情報取得時（外部連携からのリダイレクトなど）、外部連携アカウント登録時
      state.surname = data.surname
      state.firstname = data.firstname
      state.isLoggedIn = true
      state.isRegistered = data.registered

    },
    clearUserInfo(state) {
      state.accessToken = null
      state.surname = null
      state.firstname = null
      state.isLoggedIn = false
      state.isRegistered = false
    },
    setProjectInfo(state, data) {
      state.project.projectCode = data.projectCode
      state.project.workflowName = data.workflowName
      state.project.dataList = data.dataList
    },
    clearProjectInfo(state) {
      state.project.projectCode = null
      state.project.workflowName = null
      state.project.dataList = []
    },
  },
  actions: {
    login({ commit }, loginData) {
      let params = new URLSearchParams()
      params.append('username', loginData.username)
      params.append('password', loginData.password)
      return new Promise((resolve, reject) => {
        axios
          .post('/ui_api/login', params)
          .then((response) => {
            commit('setUserInfoToken', response.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    logout({ state, commit }) {
      const hasToken = !!state.accessToken
      commit('clearUserInfo')
      commit('clearProjectInfo')
      return new Promise((resolve, reject) => {
        if (hasToken) {
          resolve('Logged out with token');
        } else {
          return axiosCredentials
            .post('/ui_api/logout')
            .then((response) => {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
            })
        }
      })
    },
    setUserInfoToken({ commit }, data) {
      commit('setUserInfoToken', data)
    },
    setUserInfo({ commit }, data) {
      commit('setUserInfo', data)
    },
    clearUserInfo({ commit }) {
      commit('clearUserInfo')
      commit('clearProjectInfo')
    },
    setProjectInfo({ commit }, data) {
      commit('setProjectInfo', data)
    },
  },
  plugins: [
    // reload時にも保持するようSessionStorageに持つ
    createPersistedState({
      key: 'plr2App',
      storage: window.sessionStorage,
    }),
  ],
})
